import { vsComponentName as partLocationComponentName } from "./items/partLocation/component";
import { vsComponentName as checkedOutPartComponentName } from "./items/checkedOutPart/component";
import { vsComponentName as machinePartComponentName } from "./items/machinePart/component";
import { vsComponentName as partTransactionDetailPartOrderItemComponentName } from "./items/partOrderItem";

import {
  vsProviderName as PartTransactionDetailComponentServiceProviderName,
  PartTransactionDetailComponentServiceProvider,
} from "./provider";
import { vsComponentName as partTransactionDetailVoidPartLocationItemComponentName } from "./items/voidPartLocation";

partTransactionDetailConfig.$inject = [
  PartTransactionDetailComponentServiceProviderName,
];
export function partTransactionDetailConfig(
  partTransactionDetailComponentServiceProvider: PartTransactionDetailComponentServiceProvider
) {
  partTransactionDetailComponentServiceProvider.add({
    componentName: partLocationComponentName,
    tableName: "PartLocation",
  });
  partTransactionDetailComponentServiceProvider.add({
    componentName: checkedOutPartComponentName,
    tableName: "CheckedOutPart",
  });
  partTransactionDetailComponentServiceProvider.add({
    componentName: machinePartComponentName,
    tableName: "MachinePart",
  });
  partTransactionDetailComponentServiceProvider.add({
    componentName: partTransactionDetailPartOrderItemComponentName,
    tableName: "PartOrderItem",
  });
  partTransactionDetailComponentServiceProvider.add({
    componentName: partTransactionDetailVoidPartLocationItemComponentName,
    tableName: "VoidPartLocation",
  });
}
